import React, { Fragment } from "react";
import { Seo, ScrollTopBtn } from "../components";
import {
  HeaderThree,
  HeroTwo,
  FeatureTwo,
  AboutThree,
  // TeamTwo,
  CounterTwo,
  AboutFour,
  ServiceTwo,
  // ProjectOne,
  // PricePlanOne,
  ContactOne,
  BlogFour,
  ProcessOne,
  BrandTwo,
  FooterTwo,
} from "../containers";

const HomeTwo = () => (
  <Fragment>
    <Seo
      title="Home - Tech Ayukta"
      description="Tech Ayukta delivers innovative IT solutions including Web Development, Mobile Apps, UI/UX Design, Cloud, and Digital Transformation services to help businesses scale."
      keywords="Tech Ayukta, Web Development, Mobile Apps, UI/UX, Cloud Solutions, IT Services"
      canonical="https://www.techayukta.com/"
    />

    <HeaderThree />
    <HeroTwo />
    <FeatureTwo className="space-top" />
    <AboutThree />
    {/* <TeamTwo className="space-top space-extra-bottom"/> */}
    <CounterTwo className="space" />
    <AboutFour className="space space-extra-bottom" />
    <ServiceTwo className="space space-extra-bottom" />
    <ProcessOne className="space-top space-extra-bottom" />
    {/* <ProjectOne className="space-top"/> */}
    {/* <PricePlanOne className=" space-extra"/> */}
    <ContactOne />
    <BlogFour className="space-top space-extra-bottom"/>
    <BrandTwo className="space" />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default HomeTwo;

// {
//     "name": "Home",
//     "path": "/",
//     "subMenu": [
//       {
//         "name": "Home One",
//         "path": "/"
//       },
//       {
//         "name": "Home Two",
//         "path": "/home-two"
//       },
//       {
//         "name": "Home Three",
//         "path": "/home-three"
//       }
//     ]
//   },
// {
//     "name": "Blog",
//     "path": "/blog",
//     "subMenu": [
//       {
//         "name": "Blog List",
//         "path": "/blog"
//       },
//       {
//         "name": "Blog Grid",
//         "path": "/blog-grid"
//       },
//       {
//         "name": "Blog Details",
//         "path": "/blog-details"
//       }
//     ]
//   },

// {
//   "name": "Pages",
//   "path": "/",
//   "subMenu": [
//     {
//       "name": "Team",
//       "path": "/team"
//     },
//     {
//       "name": "Team Details",
//       "path": "/team-details"
//     },
//     {
//       "name": "Projects",
//       "path": "/project"
//     },
//     {
//       "name": "Projects Details",
//       "path": "/project-details"
//     },
//     {
//       "name": "Pricing Plans",
//       "path": "/price-plan"
//     },
//     {
//       "name": "Error Page",
//       "path": "/error-page"
//     }
//   ]
// },
